import { FC } from 'react';
import cx from 'classnames';

import { IconProps } from './type';

export const CallTransferIcon: FC<IconProps> = ({ className }) => (
  <svg
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    className={cx(className, 'fill-current')}
  >
    <path d="M7.035 2.116c-1.04-.264-2.13-.151-2.984.327-.87.486-1.48 1.347-1.51 2.5-.046 1.802.371 4.22 2.027 7.059 1.635 2.802 3.44 4.482 4.938 5.48.946.632 1.991.649 2.884.237.88-.405 1.594-1.213 1.965-2.217a1.838 1.838 0 0 0-.12-1.535l-.804-1.436a2.5 2.5 0 0 0-3.441-.938l-.437.255c-.349.204-.704.155-.898-.048-.652-.682-1.245-1.679-1.513-2.576-.075-.252.045-.568.372-.776l.79-.501a2.5 2.5 0 0 0 .829-3.354l-.898-1.566a1.929 1.929 0 0 0-1.2-.91zm4.611 6.737a.5.5 0 0 1 0-.707L16.793 3H13a.5.5 0 1 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V3.707l-5.146 5.146a.5.5 0 0 1-.708 0z" />
  </svg>
);
